import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HeaderService } from './header.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebAlertService {
  constructor(
    private headerService: HeaderService,
    private http: HttpClient
  ) {}

  getAlertData(): Observable<any> {
    const url = `${environment.rootApiUrl}/users/alert`;

    return this.http.get<any>(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  setAlertData(title: string, detail: string): Observable<any> {
    const url = `${environment.rootApiUrl}/users/alert/update`;
    const body = {
      title: title,
      detail: detail
    };
    let headers = this.headerService.getXAuthHeaderFromCookie();
    headers = headers.set('Content-Type', 'application/json');

    return this.http.post<any>(url, body, {headers: headers});
  }
}
